import { useState } from "react"
//import { useDocumentsContext } from "../hooks/useDocumentsContext"
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from "../context/AuthContext"
import { _CREATE } from '../utils/patches'
import { useMutation,  } from "@tanstack/react-query"
import queryClient from '../utils/queryClient'
import { useStateContext } from "../context/StateContext"

const DocumentForm = () => {
  //const { dispatch } = useDocumentsContext()
  const { user } = useAuthContext(AuthContext)
  const {apiUrl} = useStateContext()
  const [title, setTitle] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [error, setError] = useState(null)
  const [emptyFields, setEmptyFields] = useState([])
  const onError = (e) => {
    setError(e.error)
    setEmptyFields(e.emptyFields)
  }
  const onSuccess = (json) => {
    setTitle('')
    setFirstName('')
    setLastName('')
    setError(null)
    setEmptyFields([])
    //dispatch({type: 'CREATE_DOCUMENT', payload: json})
  }
  const { mutate } = useMutation({  
    mutationFn: async(doc) => {
      return await _CREATE({doc, user, route: `${apiUrl}/documents`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['documentsData'] }),
    mutationKey: ['documentsData'],
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!user) {
      setError('You must be logged in')
      return
    }

    const doc = {title, firstName, lastName}
    mutate(doc)
  }

  return (
    <form className="create" onSubmit={handleSubmit}>
      <h3>Add a New doc</h3>

      <label>Title:</label>
      <input 
        type="text"
        onChange={(e) => setTitle(e.target.value)}
        value={title}
        className={emptyFields?.includes('title') ? 'error' : ''}
      />

      <label>First Name:</label>
      <input 
        type="text"
        onChange={(e) => setFirstName(e.target.value)}
        value={firstName}
        className={emptyFields?.includes('firstName') ? 'error' : ''}
      />

      <label>Last Name:</label>
      <input 
        type="text"
        onChange={(e) => setLastName(e.target.value)}
        value={lastName}
        className={emptyFields?.includes('lastName') ? 'error' : ''}
      />

      <button>Add doc</button>
      {error && <div className="error">{error}</div>}
    </form>
  )
}

export default DocumentForm